import { ExpandMore as ExpandMoreIcon } from "@mui/icons-material";
import { Card, CardContent, CardHeader, Collapse } from "@mui/material";
import { AxiosError } from "axios";
import { useContext, useEffect, useState } from "react";
import { HttpClientContext, X_REQUEST_ID } from "../../app/client";
import Error from "../common/Error";
import ExpandMore from "../common/ExpandMore";
import ItemFormApproval from "../common/items/ItemFormApproval";
import ItemLoader from "../common/items/ItemLoader";
import Loading from "../common/Loading";

interface ApprovalSchema {
  kind: string;
  sub_kinds: string[] | null;
}

function Approvals() {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | undefined>(undefined);
  const [schemas, setSchemas] = useState<ApprovalSchema[]>([]);

  const client = useContext(HttpClientContext);

  useEffect(() => {
    client
      ?.get<ApprovalSchema[]>("/api/approvals")
      .then((res) => setSchemas(res.data))
      .catch((e: AxiosError) => setError(e.response?.headers[X_REQUEST_ID]))
      .finally(() => setLoading(false));
  }, [client]);

  let comp = <></>;
  if (loading) comp = <Loading />;
  else if (error) comp = <Error error={error} />;
  else
    comp = (
      <>
        {schemas.map((schema, i) => (
          <ApprovalKind key={i} schema={schema} />
        ))}
      </>
    );

  return <>{comp}</>;
}

export default Approvals;

function ApprovalKind(props: { schema: ApprovalSchema }) {
  const { schema } = props;

  const [expanded, setExpanded] = useState(false);

  const handleExpandClick = () => {
    setExpanded(!expanded);
  };

  return (
    <Card sx={{ width: "100%", maxWidth: "sm" }}>
      <CardHeader
        title={schema.kind}
        action={
          <ExpandMore expand={expanded} onClick={handleExpandClick}>
            <ExpandMoreIcon />
          </ExpandMore>
        }
      />
      <Collapse in={expanded} timeout="auto">
        <CardContent
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: 2,
          }}
        >
          {schema.sub_kinds !== null ? (
            schema.sub_kinds.map((kind, i) => (
              <ApprovalSubKind key={i} kind={schema.kind} subKind={kind} />
            ))
          ) : (
            <ItemLoader
              kind={`${schema.kind}`}
              variant="approvals"
              render={(item) => (
                <ItemFormApproval item={item} kind={schema.kind} />
              )}
            />
          )}
        </CardContent>
      </Collapse>
    </Card>
  );
}

function ApprovalSubKind(props: { kind: string; subKind: string }) {
  const { kind, subKind } = props;

  const [expanded, setExpanded] = useState(false);

  const handleExpandClick = () => {
    setExpanded(!expanded);
  };

  return (
    <Card elevation={2}>
      <CardHeader
        title={subKind}
        action={
          <ExpandMore expand={expanded} onClick={handleExpandClick}>
            <ExpandMoreIcon />
          </ExpandMore>
        }
      />
      <Collapse in={expanded} timeout="auto">
        <CardContent>
          <ItemLoader
            kind={`${kind}/${subKind}`}
            variant="approvals"
            render={(item) => (
              <ItemFormApproval item={item} kind={kind} subKind={subKind} />
            )}
          />
        </CardContent>
      </Collapse>
    </Card>
  );
}
